import { Button } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

export interface FollowListButtonProps {
  isFollowing: boolean;
  onClick: () => void;
  isPending?: boolean;
  ariaLabel?: string;
}

// Visual treatment lives in the `followListCTA` / `followListCTAActive`
// theme variants (theme/components/Button.ts). This wrapper just picks the
// right one based on the follow state and handles a11y + the click guard.
//
// Auth gating and analytics are deliberately not built in — those belong
// to the surface that mounts the button (different surfaces want
// different funnel modals and tracking events). Pair with
// `useToggleListFollow` for the mutation logic.
export function FollowListButton({
  isFollowing,
  onClick,
  isPending,
  ariaLabel,
}: FollowListButtonProps) {
  const [t] = useTranslation();
  const label = isFollowing
    ? t("screens.shelf.readingLists.layout.followingButton")
    : t("screens.shelf.readingLists.layout.followButton");

  return (
    <Button
      variant={isFollowing ? "followListCTAActive" : "followListCTA"}
      aria-label={ariaLabel ?? label}
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
        if (!isPending) onClick();
      }}
      isLoading={isPending}
    >
      {label}
    </Button>
  );
}
